import { render, staticRenderFns } from "./VisitShopDetailTotalTable.vue?vue&type=template&id=32a2219a&scoped=true&"
import script from "./VisitShopDetailTotalTable.vue?vue&type=script&lang=js&"
export * from "./VisitShopDetailTotalTable.vue?vue&type=script&lang=js&"
import style0 from "./VisitShopDetailTotalTable.vue?vue&type=style&index=0&id=32a2219a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a2219a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VIcon,VListItem,VListItemIcon,VListItemTitle,VRow,VSelect,VSkeletonLoader})
